<template>
  <b-modal id="orderReprintModal" title="Order a Reprint:" size="lg" :hide-footer=true>
    <section>
      <p>Dear Authors and Readers,</p>
      <p>We offer on demand printing for {{siteName}} Journal and Individual Articles. Our options range from a single
        copy of a black and white article with no cover all the way up to full-color copies of complete issues.</p>
      <p>Please provide the following information and we will prepare a purchase order for your review.</p>
    </section>

    <title-block title="Paper / Issue Requested:">
      <img v-if="reprintItem.cover_url" v-bind:src="reprintItem ? reprintItem.cover_url : ''" style="float: left">
      <div>Issue: Volume {{reprintItem.volume}}, Number {{reprintItem.issue}} - {{ timestamp }} Pages: {{reprintItem.page_start}} - {{reprintItem.page_end}}</div>
      <div>About the Cover</div>
      <div>{{reprintItem.title}}</div>
      <div v-html="reprintItem.caption"></div>
      <div v-if="reprintItem.articles">{{reprintItem.articles.length}} Papers inlcuding: {{reprintItem.articlesTypes}}.
      </div>
    </title-block>

    <title-block title="Request Preferences:">
      <b-form-fieldset label="Specifications for your Request:">
        <b-form-input placeholder="Tell us about any specific requests for this Reprint" type="text"
                      v-model="requestData.specifications"/>
      </b-form-fieldset>
      <div class="devider"></div>
      <div class="row">
        <div class="col-4">
          <b-form-fieldset :class="{error: attemptSubmit && !validation.includeSupplementaryMaterial}"
                           label="Include Supplementary material?">
            <b-form-radio type="text" :options="['Yes', 'No']" v-model="requestData.includeSupplementaryMaterial"/>
          </b-form-fieldset>
        </div>
        <div class="col-4">
          <b-form-fieldset :class="{error: attemptSubmit && !validation.colorScheme}"
                           label="Print in Color or Black & White?">
            <b-form-radio type="text" :options="['Color', 'Black & White']" v-model="requestData.colorScheme"/>
          </b-form-fieldset>
        </div>
        <div class="col-4">
          <b-form-fieldset :class="{error: attemptSubmit && !validation.includeCover}" label="Include Cover?">
            <b-form-radio type="text" :options="['Yes', 'No']" v-model="requestData.includeCover"/>
          </b-form-fieldset>
        </div>
      </div>
    </title-block>

    <title-block title="Shipping Details:">
      <b-form-fieldset :class="{error: attemptSubmit && !validation.name}" label="Name">
        <b-form-input placeholder="Enter Full  Name" type="text" v-model="requestData.name"/>
      </b-form-fieldset>
      <div class="devider"></div>
      <b-form-fieldset label="Email Address" :class="{error: attemptSubmit && !validation.email}">
        <b-form-input placeholder="Enter Email Address" type="text" v-model="requestData.email"/>
      </b-form-fieldset>
      <div class="devider"></div>
      <b-form-fieldset label="Phone Namber" :class="{error: attemptSubmit && !validation.phone}">
        <b-form-input v-model="requestData.phone" placeholder="Enter Phone Number" :formatter="phoneFormater"/>
      </b-form-fieldset>
      <div class="devider"></div>
      <b-form-fieldset :class="{error: attemptSubmit && !validation.instruction}" label="Institution">
        <b-form-input placeholder="Enter Your Affiliated Institution" type="text" v-model="requestData.instruction"/>
      </b-form-fieldset>
      <div class="devider"></div>
      <b-form-fieldset :class="{error: attemptSubmit && !validation.address}"
                       label="Shipping Address, including Zip Code">
        <b-form-input placeholder="Enter Your Shipping Address" type="text" v-model="requestData.address"/>
      </b-form-fieldset>

      <button v-on:click="request()">Submit</button>
      <div v-if="attemptSubmit && !isValid">Error</div>
    </title-block>
  </b-modal>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import FormatersMixin from '@/components/shared/mixins/FormatersMixin'
  import moment from 'moment'
  export default {
    components: {
      TitleBlock,
      CondensedIssue
    },
    mixins: [UtilityMixin, FormatersMixin],
    data () {
      return {
        siteName: process.env.SITE_NAME,
        reprintItem: {
          volume: '',
          issue: '',
          page_start: '',
          page_end: '',
          date: '',
          caption: '',
          title: '',
          cover_url: '',
          articles: ''
        },
        requestData: {
          specifications: '',
          includeSupplementaryMaterial: '',
          colorScheme: '',
          includeCover: '',
          name: '',
          email: '',
          phone: '',
          instruction: '',
          address: ''
        },
        attemptSubmit: false
      }
    },
    name: 'order-reprint-modal',
    created () {
      this.$root.$on('show::modal', function (modalName, item) {
        if (modalName !== 'orderReprintModal') {
          return
        }
        console.log(item)
        if (item.cover) {
          this.reprintItem = {
            'cover_url': item.optimized_urls.small,
            'volume': item.volume,
            'issue': item.issue,
            'page_end': item.pages.end,
            'page_start': item.pages.start,
            'title': item.title,
            'date': item.pub_date,
            'caption': item.caption,
            'articles': item.articles,
            'articlesTypes': item.articles.map((item) => { return item.article_type.name }).filter(function (item, i, allItems) {
              return i === allItems.indexOf(item)
            }).join(', ')
          }
        } else if (item.issue.issue) {
          this.reprintItem = {
            'cover_url': item.issue.optimized_urls.small,
            'volume': item.volume,
            'issue': item.issue.issue,
            'page_end': item.page_end,
            'page_start': item.page_start,
            'title': item.title,
            'date': item.dates.epub,
            'caption': item.issue.caption
          }
        } else {
          this.reprintItem = {
            'cover_url': '',
            'volume': item.volume,
            'issue': item.issue,
            'page_end': item.page_end,
            'page_start': item.page_start,
            'title': item.title,
            'date': item.dates.epub,
            'caption': ''
          }
        }
      }.bind(this))
    },
    methods: {
      request () {
        if (this.isValid) {
          console.log(JSON.parse(JSON.stringify(this.requestData)), this.isValid, this.requestData)
          this.attemptSubmit = false
          this.$root.$emit('hide::modal', 'orderReprintModal')
        } else {
        }
      }
    },
    computed: {
      validation: function () {
        var emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return {
          includeSupplementaryMaterial: !!this.requestData.includeSupplementaryMaterial.trim(),
          colorScheme: !!this.requestData.colorScheme.trim(),
          includeCover: !!this.requestData.includeCover.trim(),
          name: !!this.requestData.name.trim(),
          email: emailRE.test(this.requestData.email),
          phone: /^\(\d\d\d\)\s\d\d\d-\d\d\d\d$/.test(this.requestData.phone),
          instruction: !!this.requestData.instruction.trim(),
          address: !!this.requestData.address.trim()
        }
      },
      isValid: function () {
        var validation = this.validation
        this.attemptSubmit = true
        return Object.keys(validation).every(function (key) {
          return validation[key]
        })
      },
      timestamp: function () {
        return moment(this.reprintItem.date).format('MMMM DD,YYYY')
      }
    }
  }
</script>

<style lang="scss">
  .modal {
    &.show {
       display: block;
    }
  }
</style>

<style lang="scss" scoped>
  .error {
    color: red;
  }
  img {
    float: left;
    width: 120px;
    margin: 15px 15px 15px 0;
  }
  label {
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
  }
</style>




// WEBPACK FOOTER //
// OrderReprintComponent.vue?3bc99b16